module.exports = __webpack_public_path__ + "media/images/countryrect/lt-a967b3724aa8efb05601126646e34a98.svg";